(() => {
  angular
    .module('app')
    .controller(
      'host.views.inpatientTreatmentCategories.importResultModal',
      InpatientTreatmentCategoryImportResultModalController
    );

  InpatientTreatmentCategoryImportResultModalController.$inject = ['$uibModalInstance', 'errors'];

  function InpatientTreatmentCategoryImportResultModalController($uibModalInstance, errors) {
    const vm = this;
    vm.errorCountText = App.localize('ImportFileHasXIssues', errors.length);
    vm.errorText = errors.join('\n');

    vm.cancel = cancel;

    function cancel() {
      $uibModalInstance.dismiss();
    }
  }
})();
